import { azureFetch } from "./azureFetch";

export const fetchAlertsFilterData = async(filters) => {
    try {
        const response = await azureFetch('alerts-filter-data', {
            where_clause: filters
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching alerts filter data:", error);
        throw error;
    }
};

export const fetchCorrosionAlertsChartData = async(filters) => {
    try {
        const response = await azureFetch('corrosion-alerts-chart-data', {
            where_clause: filters
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching corrosion alerts chart data:", error);
        throw error;
    }
};

export const fetchRemantAlertsChartData = async(filters) => {
    try {
        const response = await azureFetch('remnant-alerts-chart-data', {
            where_clause: filters
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching remnant alerts chart data:", error);
        throw error;
    }
};

export const fetchCorrosionRateAlertsData = async (filters, limit, offset, order_by, order_dir) => {
    try {
        const response = await azureFetch('corrosion-rate-alerts-data', {
            where_clause: filters,
            limit,
            offset,
            order_by,
            order_dir
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching corrosion rate alerts data:", error);
        throw error;
    }
};

export const fetchAlertsCount = async (filters) => {
    try {
        const response = await azureFetch('alerts-count', {
            where_clause: filters
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching alerts count:", error);
        throw error;
    }
};

export const fetchRemnanatCount = async (filters) => {
    try {
        const response = await azureFetch('remnant-count', {
            where_clause: filters
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching remnant count:", error);
        throw error;
    }
};

export const fetchThicknessCount = async (filters) => {
    try {
        const response = await azureFetch('thickness-count', {
            where_clause: filters
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching thickness count:", error);
        throw error;
    }
};


export const fetchRemnantLifeAlertsData = async (filters, limit, offset, order_by, order_dir) => {
    try {
        const response = await azureFetch('remnant-life-alerts-data', {
            where_clause: filters,
            limit,
            offset,
            order_by,
            order_dir
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching remnant life alerts data:", error);
        throw error;
    }
};

export const fetchWallThicknessAlertsData = async (filters, limit, offset, order_by, order_dir) => {
    try {
        const response = await azureFetch('wall-thickness-alerts-data', {
            where_clause: filters,
            limit,
            offset,
            order_by,
            order_dir
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching wall thickness alerts data:", error);
        throw error;
    }
};

